import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Apply the saved theme before first paint (prevents a light->dark flash).
try {
  const savedTheme = localStorage.getItem('bf-theme');
  if (savedTheme) document.documentElement.setAttribute('data-theme', savedTheme);
} catch (e) { /* localStorage unavailable */ }

// Kill any zombie service worker from the 2021-era build (it pinned users to
// a cached old app across deploys) and drop its caches. The server also
// serves a self-destructing /service-worker.js for browsers that never load
// this far on fresh code.
try {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister()));
  }
  if (window.caches && caches.keys) {
    caches.keys().then((ks) => ks.forEach((k) => caches.delete(k)));
  }
} catch (e) { /* best effort */ }

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


